import { render, staticRenderFns } from "./detailApp.vue?vue&type=template&id=6113374b&scoped=true"
import script from "./detailApp.vue?vue&type=script&lang=js"
export * from "./detailApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6113374b",
  null
  
)

export default component.exports